<div class="container mt-4">
  <h3>Update Profile</h3>
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">

    <div class="form-group mb-3">
      <label for="fullName">Full Name</label>
      <input id="fullName" type="text" formControlName="fullName" class="form-control" />
    </div>

    <div class="form-group mb-3">
      <label for="email">Email</label>
      <input id="email" type="email" formControlName="email" class="form-control" readonly />
    </div>

    <div class="form-group mb-3">
      <label for="role">Role</label>
      <input id="role" type="text" formControlName="role" class="form-control" readonly />
    </div>

    <div class="form-group mb-3">
      <label for="password">New Password</label>
      <input id="password" type="password" formControlName="password" class="form-control" />
    </div>

    <button type="submit" class="btn btn-primary" [disabled]="profileForm.invalid">Update Profile</button>
  </form>
</div>
